import { render, staticRenderFns } from "./ChangeMember.vue?vue&type=template&id=8b3deb60&scoped=true&"
import script from "./ChangeMember.vue?vue&type=script&lang=js&"
export * from "./ChangeMember.vue?vue&type=script&lang=js&"
import style0 from "./ChangeMember.vue?vue&type=style&index=0&id=8b3deb60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b3deb60",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import ClickOutside from 'vuetify/lib/directives/click-outside'
installDirectives(component, {ClickOutside})
